import styled from 'styled-components';

import background from '../../assets/random-shapes.svg';

export const Wrapper = styled.div`
  height: 100%;
  background: #f6f6f6 url(${background}) 10px repeat;
`;
